import { initializeApp } from 'firebase/app';
import { ref, getStorage, uploadString, getDownloadURL } from 'firebase/storage';
import { nanoid } from 'nanoid';
import { firebase } from '../config';

// Inicializar Firebase
const app = initializeApp(firebase);
const storage = getStorage(app);
const refs = {
 logosRef: ref(storage, 'logos'),
 avatarsRef: ref(storage, 'avatars'),
 DNIsRef: ref(storage, 'DNIs')
};

export const uploadBase64 = async (data, folder = 'logosRef') => {
 const images = [];
 console.log(data, 'lo que procesa fb-storage');
 if (typeof data === 'string') return [data];

 if (typeof data[0] === 'string') return data;

 try {
  for (var i = 0; i < data.length; i++) {
   const url = await uploadString(ref(refs[folder], `${nanoid()}`), data[i].base64, 'data_url');
   images.push(await getDownloadURL(url.ref));
  }
  console.log(images, 'esta procesando las imagenes nuevamente');
  return images;
 } catch (error) {
  console.log(error);
  return [];
 }

 /* return uploadString(ref(refs.logosRef, `${nanoid()}`), stringBase64, 'data_url')
  .then(snapshot => {
   console.log(snapshot, 'paso la carga del archivo');
   return getDownloadURL(snapshot.ref);
  })
  .catch(error => {
   console.error(error);
   return false;
  }); */
};

/* module.exports.uploadFile = (file, rf) => {
 const storageRef = ref(refs[rf], `${nanoid()}`);
 console.log(storageRef, rf);
 return uploadBytes(storageRef, file)
  .then(snapshot => {
   console.log(snapshot, 'paso la carga del archivo');
   return getDownloadURL(snapshot.ref);
  })
  .catch(error => {
   console.error(error);
   return false;
  });
}; */

/* 
module.exports.uploadBase64 = async stringBase64 => {
  console.log(stringBase64);
  try {
    const fileRef = ref(logosRef, nanoid());
    console.log(fileRef);
    const res = await uploadString(fileRef, stringBase64, 'data_url');
    console.log(res);
    return await getDownloadURL(fileRef);
  } catch (error) {
    console.log(error);
    return false;
  }
};
 */
